module.exports = __webpack_public_path__ + "media/images/steps/step_2-4fdbd1a91ea6d55923c77783a46a9cd3.svg";